import { faHeart, faUserGroup } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

import { DumbWatchlistHeader } from '#src/components/watchlists/DumbWatchlistHeader/index.tsx';

const Title = styled(Vertical)`
  align-items: flex-start;
`;

const Metas = styled(LabelS)`
  svg {
    margin-right: var(--unit);
  }
`;

type Props = {
  count: number;
  playerUrls: string[];
};

export const FavoritesHeader = ({ playerUrls, count }: Props) => {
  return (
    <DumbWatchlistHeader
      title={
        <Title as="span">
          <FontAwesomeIcon icon={faHeart} size="lg" />
          <FormattedMessage {...glossary.favorites} />
        </Title>
      }
      playerUrls={playerUrls}
      metas={
        <Metas color="var(--c-nd-600)">
          <FontAwesomeIcon icon={faUserGroup} color="var(--c-nd-600)" />
          <FormattedMessage
            defaultMessage="{totalPlayersCount, plural, one {# player} other {# players}}"
            values={{ totalPlayersCount: count }}
          />
        </Metas>
      }
    />
  );
};
